export default __webpack_public_path__ + "static/media/+.15454e73.svg";